import { render, staticRenderFns } from "./enviarOrden.vue?vue&type=template&id=2e1fa51c&scoped=true&"
import script from "./enviarOrden.vue?vue&type=script&lang=js&"
export * from "./enviarOrden.vue?vue&type=script&lang=js&"
import style0 from "./enviarOrden.vue?vue&type=style&index=0&id=2e1fa51c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1fa51c",
  null
  
)

export default component.exports